import { observable, action, when } from 'mobx'
import routingStore from './routingStore'
import api from '../api'

class PagesStore {

  @observable pages = {}
  @observable loadingPage = false
  @observable updatingPage = false

  constructor() {
    when(
      () => routingStore.location && routingStore.location.pathname.startsWith('/page'),
      () => this.fetchPages()
    )
  }

  @action fetchPages() {


    this.loadingPages = true
    return api.Pages.getAll()
      .then(transformResponse)
      .then(action(( pages ) => { this.pages = pages }))
      .finally(action(() => { this.loadingPages = false }))
  }

}

const transformResponse = pagesArr => {
  let pagesObj = {}
  pagesArr.forEach(page => {
    pagesObj[page.alias] = {...page}
  })
  return pagesObj
}

export default new PagesStore()



// WEBPACK FOOTER //
// ./src/stores/pagesStore.js